import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  MessageBox,
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Menu,
  MenuItem,
  Submenu,
  Badge,
  Tooltip,
  Scrollbar,
  Card,
  Select,
  Option,
  OptionGroup,
  Table,
  TableColumn,
  Loading,
  Switch,
  Icon,
  Pagination,
  Tag,
  DatePicker,
  Transfer,
  Tree,
  Checkbox,
  Upload,
  Tabs,
  TabPane,
  Notification,
  Radio,
  RadioGroup,
  TimeSelect,
  Popover,
  Empty,
  Divider,
  InputNumber,
  Descriptions,
  DescriptionsItem,
  Aside,
  Container,
  Header,
  Main,
  Footer,
  Alert,
  Link,
  Popconfirm,
} from 'element-ui';

const setupElement = {
  install: (Vue) => {
    Vue.use(Button)
      .use(Form)
      .use(FormItem)
      .use(Input)
      .use(Row)
      .use(Col)
      .use(Breadcrumb)
      .use(BreadcrumbItem)
      .use(Dropdown)
      .use(DropdownMenu)
      .use(DropdownItem)
      .use(Dialog)
      .use(Dropdown)
      .use(Menu)
      .use(MenuItem)
      .use(Submenu)
      .use(Badge)
      .use(Tooltip)
      .use(Scrollbar)
      .use(Card)
      .use(Select)
      .use(Option)
      .use(OptionGroup)
      .use(Table)
      .use(TableColumn)
      .use(Loading.directive)
      .use(Switch)
      .use(Icon)
      .use(Pagination)
      .use(Tag)
      .use(DatePicker)
      .use(Transfer)
      .use(Tree)
      .use(Checkbox)
      .use(Upload)
      .use(Tabs)
      .use(TabPane)
      .use(Radio)
      .use(RadioGroup)
      .use(TimeSelect)
      .use(Popover)
      .use(Empty)
      .use(Divider)
      .use(Descriptions)
      .use(DescriptionsItem)
      .use(Aside)
      .use(Container)
      .use(Header)
      .use(Main)
      .use(Footer)
      .use(Link)
      .use(Alert)
      .use(Popconfirm)
      .use(InputNumber);
    Vue.prototype.$loading = Loading.service;
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
    Vue.prototype.$notify = Notification;
    Vue.prototype.$message = Message;
    Vue.prototype.$ELEMENT = { size: 'small' };
  },
};
export default setupElement;
